import React from 'react'
import DiscoLogo from '@disco/accounts/components/ui/logo'
import { useTranslation } from '@disco/i18n/use-translation'

interface SuccessStepProps {
  data: Record<string, unknown>
}

export default function SuccessStep({ data }: SuccessStepProps) {
  const { t } = useTranslation('accounts')
  const email = data.email as string
  const fullName = data.fullName as string
  const firstName = fullName?.split(' ')[0] || ''

  return (
    <div className="min-h-screen bg-white relative flex flex-col items-center justify-center p-4">
      <div className="absolute top-[52px] left-[57px]">
        <DiscoLogo className="text-black" />
      </div>

      <div className="flex flex-col items-center gap-4 text-center">
        <h1 className="font-plakat font-bold text-[96px] leading-[96px] uppercase text-black m-0">
          {t('accounts:thanks', 'Thanks {{firstName}}!', { firstName })}
        </h1>
        <p className="font-neue text-[20px] leading-[30px] text-black text-center max-w-[488px] m-0">
          {t(
            'accounts:ourTeamIsReviewingYourSignupAndWillBeInTouchVia',
            'Our team is reviewing your signup and will be in touch via',
          )}{' '}
          <span className="font-bold">{email}</span>
        </p>
      </div>
    </div>
  )
}
